module.exports = __webpack_public_path__ + "img/chevron-right.d689fd2a.svg";